<template>
    <el-form
        ref="orderForm"
        :model="form"
        :rules="rules"
        :label-position="compact ? 'left' : 'top'"
        :label-width="compactLabelWidth"
        class="order-create-form"
        :class="{ 'order-create-form--compact': compact }"
    >
        <div class="order-create-form__section">
            <div v-if="!compact" class="order-create-form__section-title">企业信息</div>
            <div v-if="!compact" class="order-create-form__section-desc">
                保留最常用字段，方便前台快速录入。
            </div>
            <el-row :gutter="rowGutter">
                <el-col :span="24" :sm="colHalf">
                    <el-form-item label="公司名称" prop="company.name">
                        <el-input v-model.trim="form.company.name" placeholder="请输入公司名称" />
                    </el-form-item>
                </el-col>
                <el-col :span="24" :sm="colHalf">
                    <el-form-item label="统一信用代码" prop="company.credit_code">
                        <el-input v-model.trim="form.company.credit_code" maxlength="18" placeholder="请输入18位统一信用代码" />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="rowGutter">
                <el-col :span="24" :sm="colLegalName">
                    <el-form-item label="法人姓名" prop="company.legal_name">
                        <el-input
                            v-model.trim="form.company.legal_name"
                            class="order-create-form__input-legal-name"
                            placeholder="请输入法人姓名"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" :sm="colLegalIdNo">
                    <el-form-item label="法人身份证" prop="company.legal_id_no">
                        <el-input v-model.trim="form.company.legal_id_no" maxlength="18" placeholder="请输入18位身份证号" />
                    </el-form-item>
                </el-col>
                <el-col :span="24" :sm="colPhone">
                    <el-form-item label="法人手机号" prop="company.phone">
                        <el-input v-model.trim="form.company.phone" maxlength="11" placeholder="请输入11位手机号" />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="rowGutter" class="order-create-form__channel-row">
                <el-col :span="24" :sm="colLegalName">
                    <el-form-item label="是否渠道单">
                        <el-switch
                            v-model="form.order.is_channel_order"
                            :active-value="1"
                            :inactive-value="0"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="Number(form.order.is_channel_order) === 1" :span="24" :sm="18">
                    <el-form-item label="选择渠道" prop="order.channel_id">
                        <el-select
                            v-model="form.order.channel_id"
                            placeholder="请选择渠道"
                            filterable
                            clearable
                            :loading="channelsLoading"
                            class="full-width"
                            @change="onChannelSelectionChange"
                        >
                            <el-option
                                v-for="item in channelList"
                                :key="item.id"
                                :label="formatChannelOptionLabel(item)"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row v-if="Number(form.order.is_channel_order) === 1" :gutter="rowGutter" class="order-create-form__channel-fees">
                <el-col :span="24">
                    <div class="order-create-form__channel-fees-title" :class="{ 'order-create-form__channel-fees-title--compact': compact }">
                        渠道费用登记
                    </div>
                </el-col>
                <el-col :span="24" :sm="8">
                    <el-form-item label="应付渠道" prop="financial.channel_payable_total">
                        <el-input-number
                            v-model="form.financial.channel_payable_total"
                            :min="0"
                            :precision="2"
                            :step="100"
                            :controls="false"
                            class="order-create-form__channel-fee-input full-width"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" :sm="8">
                    <el-form-item label="已付渠道" prop="financial.channel_paid_total">
                        <el-input-number
                            v-model="form.financial.channel_paid_total"
                            :min="0"
                            :precision="2"
                            :step="100"
                            :controls="false"
                            class="order-create-form__channel-fee-input full-width"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" :sm="8">
                    <el-form-item label="待付渠道">
                        <el-input :value="channelFeesPendingDisplay" readonly class="order-create-form__channel-fee-readonly" />
                    </el-form-item>
                </el-col>
            </el-row>

        </div>

        <div class="order-create-form__actions">
            <el-button :type="compact ? 'text' : 'default'" @click="$emit('cancel')">取消</el-button>
            <el-button type="primary" :loading="submitting" @click="handleSubmit">{{ submitText }}</el-button>
        </div>
    </el-form>
</template>

<script>
function getFirstErrorMessage(error) {
    var errors = error && error.response && error.response.data && error.response.data.errors
        ? error.response.data.errors
        : null;
    var fieldNames;
    var index;

    if (!errors) {
        return error && error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '新增订单失败';
    }

    fieldNames = Object.keys(errors);

    for (index = 0; index < fieldNames.length; index += 1) {
        if (errors[fieldNames[index]] && errors[fieldNames[index]].length) {
            return errors[fieldNames[index]][0];
        }
    }

    return error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : '新增订单失败';
}

export default {
    name: 'OrderCreateForm',
    props: {
        compact: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: 'create'
        },
        orderId: {
            type: [Number, String],
            default: null
        },
        initialForm: {
            type: Object,
            default: null
        },
        submitText: {
            type: String,
            default: '确定'
        }
    },
    data() {
        return {
            submitting: false,
            quickLinkList: [],
            channelsLoading: false,
            channelList: [],
            guessProvinceTimer: null,
            form: this.buildInitialForm(),
            rules: {
                'company.name': [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                'company.entity_type': [{ required: true, message: '请选择主体类型', trigger: 'change' }],
                'company.credit_code': [
                    { required: true, message: '请输入统一信用代码', trigger: 'blur' },
                    { len: 18, message: '统一信用代码必须为18位', trigger: 'blur' },
                    { pattern: /^[0-9A-Za-z]{18}$/, message: '统一信用代码只能输入18位数字或字母', trigger: 'blur' }
                ],
                'company.legal_name': [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
                'company.legal_id_no': [
                    { required: true, message: '请输入法人身份证', trigger: 'blur' },
                    { len: 18, message: '法人身份证必须为18位', trigger: 'blur' },
                    { pattern: /^\d{17}[\dXx]$/, message: '法人身份证格式不正确', trigger: 'blur' }
                ],
                'company.phone': [
                    { required: true, message: '请输入法人手机号', trigger: 'blur' },
                    { pattern: /^\d{11}$/, message: '法人手机号必须为11位数字', trigger: 'blur' }
                ],
                'company.province': [{ required: true, message: '请选择公司所属省份', trigger: 'change' }],
                'order.channel_id': [
                    {
                        validator: function (rule, value, callback) {
                            if (Number(this.form.order.is_channel_order) !== 1) {
                                callback();
                                return;
                            }
                            if (value === '' || value === null || value === undefined) {
                                callback(new Error('请选择渠道'));
                            } else {
                                callback();
                            }
                        }.bind(this),
                        trigger: ['change', 'blur']
                    }
                ],
                'company.announcement_end_date': [{ required: true, message: '请选择公示结束时间', trigger: 'change' }],
                'financial.receivable_total': [{ required: true, message: '请输入应收金额', trigger: 'change' }],
                'financial.paid_total': [
                    { required: true, message: '请输入已收金额', trigger: 'change' },
                    {
                        validator: function (rule, value, callback) {
                            var receivable = Number(this.form.financial.receivable_total);
                            var paid = Number(value);

                            if (paid > receivable) {
                                callback(new Error('已收金额不能大于应收金额'));
                            } else {
                                callback();
                            }
                        }.bind(this),
                        trigger: 'change'
                    }
                ],
                'financial.for_sale_amount': [{ type: 'number', min: 0, message: '待售金额不能为负数', trigger: 'change' }],
                'financial.payment_type': [{ required: true, message: '请选择收款方式', trigger: 'change' }],
                'order.biz_announcement_status': [{ required: true, message: '请选择工商情况', trigger: 'change' }],
                'order.annual_report_stage': [{ required: true, message: '请选择年报情况', trigger: 'change' }],
                'financial.channel_payable_total': [
                    {
                        validator: function (rule, value, callback) {
                            if (Number(this.form.order.is_channel_order) !== 1) {
                                callback();
                                return;
                            }
                            var n = value === '' || value === null || value === undefined ? NaN : Number(value);
                            if (Number.isNaN(n) || n < 0) {
                                callback(new Error('应付渠道不能为负'));
                            } else {
                                callback();
                            }
                        }.bind(this),
                        trigger: 'change'
                    }
                ],
                'financial.channel_paid_total': [
                    {
                        validator: function (rule, value, callback) {
                            if (Number(this.form.order.is_channel_order) !== 1) {
                                callback();
                                return;
                            }
                            var paid = value === '' || value === null || value === undefined ? NaN : Number(value);
                            var payable = Number(this.form.financial.channel_payable_total);
                            if (Number.isNaN(paid) || paid < 0) {
                                callback(new Error('已付渠道不能为负'));
                                return;
                            }
                            if (paid > payable) {
                                callback(new Error('已付渠道费不能大于应付渠道费'));
                            } else {
                                callback();
                            }
                        }.bind(this),
                        trigger: 'change'
                    }
                ]
            }
        };
    },
    computed: {
        provinceOptions: function () {
            var map = {};
            var result = [];

            this.quickLinkList.forEach(function (item) {
                var province = (item.province || '').trim();

                if (province && !map[province]) {
                    map[province] = true;
                    result.push(province);
                }
            });

            ['广东省', '北京市'].forEach(function (province) {
                if (!map[province]) {
                    result.push(province);
                }
            });

            if (this.form.company.province && !map[this.form.company.province]) {
                result.unshift(this.form.company.province);
            }

            return result;
        },
        compactLabelWidth: function () {
            return this.compact ? '100px' : '';
        },
        rowGutter: function () {
            return this.compact ? 12 : 16;
        },
        colHalf: function () {
            return 12;
        },
        colThird: function () {
            return 8;
        },
        colLegalName: function () {
            return 6;
        },
        colLegalIdNo: function () {
            return 10;
        },
        colPhone: function () {
            return 8;
        },
        agencyCollectionAmount: function () {
            var receivable = Number(this.form.financial.receivable_total) || 0;
            var paid = Number(this.form.financial.paid_total) || 0;

            return Number((receivable - paid).toFixed(2));
        },
        channelFeesPendingDisplay: function () {
            var a = Number(this.form.financial.channel_payable_total || 0);
            var b = Number(this.form.financial.channel_paid_total || 0);
            return Math.max(0, a - b).toFixed(2);
        }
    },
    watch: {
        initialForm: {
            immediate: true,
            deep: true,
            handler: function (value) {
                if (this.mode !== 'edit' || !value) {
                    return;
                }
                this.form = this.mergeFormWithInitial(value);
            }
        },
        'form.company.credit_code': function () {
            this.tryAutoDetectProvince();
        },
        'form.financial.receivable_total': function () {
            this.syncForSaleAmount();
        },
        'form.financial.paid_total': function () {
            this.syncForSaleAmount();
        },
        'form.order.is_channel_order': function (v) {
            if (Number(v) !== 1) {
                this.form.order.channel_id = null;
                this.form.order.channel_code = '';
                this.form.order.channel_name = '';
                this.form.financial.channel_payable_total = 0;
                this.form.financial.channel_paid_total = 0;
            } else {
                this.fetchChannelList();
            }
        },
        'form.financial.channel_payable_total': function () {
            if (this.$refs.orderForm && Number(this.form.order.is_channel_order) === 1) {
                this.$refs.orderForm.validateField('financial.channel_paid_total');
            }
        }
    },
    methods: {
        fetchChannelList() {
            var _this = this;
            this.channelsLoading = true;
            window.axios
                .get('/channels', { params: { active_only: 1, for_assignment: 1 } })
                .then(function (res) {
                    var data = res.data && res.data.data;
                    _this.channelList = Array.isArray(data) ? data.map(function (ch) {
                        ch.id = ch.id != null ? String(ch.id) : null;
                        return ch;
                    }) : [];
                })
                .catch(function () {
                    _this.channelList = [];
                    _this.$message.error('渠道列表加载失败');
                })
                .finally(function () {
                    _this.channelsLoading = false;
                });
        },
        /** 渠道下拉展示：渠道名称 + 联系人（渠道管理口径） */
        formatChannelOptionLabel(item) {
            if (!item) {
                return '';
            }
            var tail = item.status === 0 || item.status === '0' ? '（停用）' : '';
            var name = item.name != null ? String(item.name) : '';
            var contact = item.contact != null ? String(item.contact).trim() : '';
            var core = contact ? (name + '-' + contact) : name;
            return core + tail;
        },
        onChannelSelectionChange(channel) {
            if (!channel) {
                this.form.order.channel_id = null;
                this.form.order.channel_code = '';
                this.form.order.channel_name = '';
                return;
            }
            var found = typeof channel === 'object' ? channel : null;
            if (!found) {
                var idStr = String(channel);
                for (var i = 0; i < this.channelList.length; i += 1) {
                    if (String(this.channelList[i].id) === idStr) {
                        found = this.channelList[i];
                        break;
                    }
                }
            }
            if (found) {
                this.form.order.channel_id = found.id != null ? String(found.id) : null;
                this.form.order.channel_code = found.code != null ? String(found.code) : '';
                this.form.order.channel_name = found.name != null ? String(found.name) : '';
            } else {
                this.form.order.channel_id = null;
                this.form.order.channel_code = '';
                this.form.order.channel_name = '';
            }
        },
        fetchQuickLinks() {
            var _this = this;
            return window.axios.get('/quick-links').then(function (response) {
                _this.quickLinkList = response.data.data || [];
                _this.tryAutoDetectProvince();
            }).catch(function () {
                _this.quickLinkList = [];
            });
        },
        normalizePlaceKeyword(value) {
            var text = String(value || '').replace(/[ 　]/g, '');
            return text.replace(/(省|市|县|区|自治州|自治县|自治区|特别行政区|盟|地区)$/u, '');
        },
        containsText(haystack, needle) {
            if (!needle) {
                return false;
            }

            return String(haystack || '').indexOf(needle) !== -1;
        },
        detectProvinceFromQuickLinks(companyName) {
            var _this = this;
            var sorted = this.quickLinkList.slice().sort(function (a, b) {
                return String(b.province || '').length - String(a.province || '').length;
            });

            for (var i = 0; i < sorted.length; i += 1) {
                var province = String(sorted[i].province || '').trim();
                var normalized = _this.normalizePlaceKeyword(province);

                if (_this.containsText(companyName, province)) {
                    return province;
                }

                if (normalized && normalized.length >= 2 && _this.containsText(companyName, normalized)) {
                    return province;
                }
            }

            return '';
        },
        detectProvinceByKeywords(companyName) {
            var map = {
                '北京市': ['北京'],
                '天津市': ['天津'],
                '上海市': ['上海'],
                '重庆市': ['重庆'],
                '广东省': ['广东', '广州', '深圳', '东莞', '佛山', '珠海', '惠州', '中山', '江门'],
                '浙江省': ['浙江', '杭州', '宁波', '温州', '嘉兴', '绍兴', '金华', '台州'],
                '江苏省': ['江苏', '南京', '苏州', '无锡', '常州', '南通', '徐州'],
                '山东省': ['山东', '济南', '青岛', '烟台', '潍坊', '临沂'],
                '河南省': ['河南', '郑州', '洛阳', '南阳', '新乡', '商丘'],
                '河北省': ['河北', '石家庄', '唐山', '保定', '廊坊', '邯郸'],
                '四川省': ['四川', '成都', '绵阳', '德阳', '宜宾', '南充'],
                '湖北省': ['湖北', '武汉', '襄阳', '宜昌', '黄石'],
                '湖南省': ['湖南', '长沙', '株洲', '湘潭', '衡阳', '岳阳'],
                '福建省': ['福建', '福州', '厦门', '泉州', '漳州'],
                '安徽省': ['安徽', '合肥', '芜湖', '蚌埠', '阜阳'],
                '江西省': ['江西', '南昌', '赣州', '九江', '上饶'],
                '广西壮族自治区': ['广西', '南宁', '柳州', '桂林'],
                '海南省': ['海南', '海口', '三亚'],
                '云南省': ['云南', '昆明', '曲靖', '大理'],
                '贵州省': ['贵州', '贵阳', '遵义', '毕节'],
                '陕西省': ['陕西', '西安', '咸阳', '宝鸡', '渭南'],
                '山西省': ['山西', '太原', '大同', '长治'],
                '辽宁省': ['辽宁', '沈阳', '大连', '鞍山'],
                '吉林省': ['吉林', '长春', '吉林市'],
                '黑龙江省': ['黑龙江', '哈尔滨', '齐齐哈尔'],
                '甘肃省': ['甘肃', '兰州', '天水'],
                '青海省': ['青海', '西宁'],
                '内蒙古自治区': ['内蒙古', '呼和浩特', '包头', '鄂尔多斯'],
                '宁夏回族自治区': ['宁夏', '银川'],
                '新疆维吾尔自治区': ['新疆', '乌鲁木齐', '喀什'],
                '西藏自治区': ['西藏', '拉萨'],
                '香港特别行政区': ['香港'],
                '澳门特别行政区': ['澳门'],
                '台湾省': ['台湾', '台北', '高雄']
            };

            var provinces = Object.keys(map);
            for (var i = 0; i < provinces.length; i += 1) {
                var province = provinces[i];
                var keywords = map[province];
                for (var j = 0; j < keywords.length; j += 1) {
                    if (this.containsText(companyName, keywords[j])) {
                        return province;
                    }
                }
            }

            return '';
        },
        tryAutoDetectProvince() {
            var _this = this;
            var companyName = String(this.form.company.name || '').trim();
            var creditCode = String(this.form.company.credit_code || '').trim();
            if (!companyName) {
                return;
            }

            if (this.guessProvinceTimer) {
                clearTimeout(this.guessProvinceTimer);
            }

            this.guessProvinceTimer = setTimeout(function () {
                _this.guessProvinceTimer = null;
                window.axios.get('/quick-links/guess-province', {
                    params: {
                        credit_code: creditCode,
                        fallback_province: _this.form.company.province || ''
                    }
                }).then(function (response) {
                    var p = response.data && response.data.data && response.data.data.province
                        ? String(response.data.data.province).trim()
                        : '';
                    if (p) {
                        _this.form.company.province = p;
                    }
                }).catch(function () {
                    var province = _this.detectProvinceFromQuickLinks(companyName) || _this.detectProvinceByKeywords(companyName);
                    if (province) {
                        _this.form.company.province = province;
                    }
                });
            }, 350);
        },
        buildInitialForm() {
            return {
                company: {
                    name: '',
                    entity_type: 1,
                    credit_code: '',
                    legal_name: '',
                    legal_id_no: '',
                    phone: '',
                    province: '广东省',
                    announcement_end_date: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
                },
                order: {
                    is_work_enabled: 0,
                    is_channel_order: 0,
                    channel_id: null,
                    channel_code: '',
                    channel_name: '',
                    tax_account_status: null,
                    biz_announcement_status: 1,
                    annual_report_stage: 1
                },
                financial: {
                    receivable_total: 0,
                    paid_total: 0,
                    for_sale_amount: 0,
                    payment_type: 1,
                    remark: '',
                    channel_payable_total: 0,
                    channel_paid_total: 0
                }
            };
        },
        mergeFormWithInitial(initial) {
            var base = this.buildInitialForm();
            var input = initial || {};
            base.company = Object.assign({}, base.company, input.company || {});
            base.order = Object.assign({}, base.order, input.order || {});
            base.financial = Object.assign({}, base.financial, input.financial || {});
            if (base.order.channel_id != null) {
                base.order.channel_id = String(base.order.channel_id);
            }
            return base;
        },
        formatAmount(value) {
            return Number(value || 0).toFixed(2);
        },
        syncForSaleAmount() {
            this.form.financial.for_sale_amount = this.agencyCollectionAmount;
        },
        resetForm() {
            this.form = this.buildInitialForm();
            this.syncForSaleAmount();

            if (this.$refs.orderForm) {
                this.$nextTick(function () {
                    this.$refs.orderForm.clearValidate();
                });
            }
        },
        handleSubmit() {
            var _this = this;
            this.syncForSaleAmount();

            this.$refs.orderForm.validate(function (valid) {
                if (!valid) {
                    return false;
                }

                _this.submitting = true;

                if (_this.mode === 'edit') {
                    var editPayload = {
                        company: {
                            name: _this.form.company.name,
                            credit_code: _this.form.company.credit_code,
                            legal_name: _this.form.company.legal_name,
                            legal_id_no: _this.form.company.legal_id_no,
                            phone: _this.form.company.phone
                        }
                    };
                    if (Number(_this.form.order.is_channel_order) === 1) {
                        editPayload.order = {
                            is_channel_order: 1,
                            channel_id: _this.form.order.channel_id != null ? Number(_this.form.order.channel_id) : null,
                            channel_code: _this.form.order.channel_code,
                            channel_name: _this.form.order.channel_name
                        };
                        editPayload.financial = {
                            channel_payable_total: _this.form.financial.channel_payable_total,
                            channel_paid_total: _this.form.financial.channel_paid_total
                        };
                    } else {
                        editPayload.order = {
                            is_channel_order: 0,
                            channel_id: null,
                            channel_code: null,
                            channel_name: null
                        };
                        editPayload.financial = {
                            channel_payable_total: 0,
                            channel_paid_total: 0
                        };
                    }
                    window.axios.put('/orders/' + _this.orderId + '/receipt', editPayload).then(function (response) {
                        _this.$emit('success', response.data.data || {});
                    }).catch(function (error) {
                        _this.$message.error(getFirstErrorMessage(error));
                    }).finally(function () {
                        _this.submitting = false;
                    });
                    return;
                }

                var payload = JSON.parse(JSON.stringify(_this.form));
                if (Number(payload.order.is_channel_order) !== 1) {
                    payload.order.is_channel_order = 0;
                    payload.order.channel_id = null;
                    payload.order.channel_code = null;
                    payload.order.channel_name = null;
                    payload.financial.channel_payable_total = 0;
                    payload.financial.channel_paid_total = 0;
                }

                window.axios.post('/orders', payload).then(function (response) {
                    var order = response.data.data || {};
                    _this.$emit('success', order);
                    _this.resetForm();
                }).catch(function (error) {
                    _this.$message.error(getFirstErrorMessage(error));
                }).finally(function () {
                    _this.submitting = false;
                });
            });
        }
    },
    created() {
        this.syncForSaleAmount();
        this.fetchQuickLinks();
        this.fetchChannelList();
    },
    beforeDestroy() {
        if (this.guessProvinceTimer) {
            clearTimeout(this.guessProvinceTimer);
            this.guessProvinceTimer = null;
        }
    }
};
</script>

<style scoped>
.order-create-form {
    padding: 4px 0 0;
}

.order-create-form__section {
    margin-bottom: 18px;
    padding: 20px 20px 10px;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);
}

.order-create-form--compact {
    padding: 6px 4px 9px;
    background: transparent;
    border: none;
    border-radius: 0;
    box-sizing: border-box;
}

.order-create-form--compact .order-create-form__section {
    margin-bottom: 0;
    padding: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
}

.order-create-form--compact .order-create-form__section--financial {
    margin-top: 0;
    padding-top: 12px;
    border-top: none;
}

.order-create-form__divider-line {
    height: 0;
    margin: 6px 0 12px;
    border: none;
    border-top: 1px solid #ebeef5;
}

.order-create-form__section-title {
    margin-bottom: 4px;
    color: #303133;
    font-size: 17px;
    font-weight: 600;
}

.order-create-form__section-desc {
    margin-bottom: 16px;
    color: #606266;
    font-size: 13px;
}

.full-width {
    width: 100%;
}

.order-create-form__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 10px;
    padding: 16px 4px 4px;
}

.order-create-form /deep/ .el-form-item {
    margin-bottom: 18px;
}

.order-create-form--compact /deep/ .el-form-item {
    margin-bottom: 8px;
}

.order-create-form--compact /deep/ .el-form-item__label {
    padding: 0 6px 0 0;
    font-size: 13px;
    font-weight: 400;
    color: #a8adb5;
    line-height: 45px;
    text-align: right;
}

.order-create-form--compact /deep/ .el-form-item__content {
    line-height: 45px;
}

.order-create-form--compact /deep/ .el-input__inner,
.order-create-form--compact /deep/ .el-select .el-input__inner,
.order-create-form--compact /deep/ .el-input-number .el-input__inner {
    height: 45px;
    line-height: 45px;
    border-radius: 4px;
    border-color: #e4e7ed;
    background: #fff;
    font-size: 14px;
    color: #5c6166;
}

.order-create-form--compact /deep/ .el-input-number .el-input__inner {
    padding-left: 12px;
    padding-right: 12px;
    text-align: left;
}

.order-create-form--compact /deep/ .el-input__inner::placeholder,
.order-create-form--compact /deep/ .el-select .el-input__inner::placeholder {
    color: #b0b4bb;
}

.order-create-form /deep/ .order-create-form__input-legal-name {
    width: 140px;
    max-width: 140px;
}

.order-create-form /deep/ .order-create-form__input-legal-name .el-input__inner {
    width: 140px;
    max-width: 140px;
    box-sizing: border-box;
}

.order-create-form--compact .order-create-form__actions {
    margin-top: 15px;
    margin-bottom: 0;
    padding: 15px 0 0;
    border-top: 1px solid #ebeef5;
    justify-content: flex-end;
    gap: 12px;
}

.order-create-form--compact .order-create-form__actions /deep/ .el-button {
    min-width: 108px;
    height: 45px;
    border-radius: 4px;
    font-size: 14px;
    padding: 0 18px;
}

.order-create-form--compact .order-create-form__actions /deep/ .el-button--primary {
    background: #409eff;
    border-color: #409eff;
}

.order-create-form--compact .order-create-form__actions /deep/ .el-button--text {
    color: #909399;
    padding-left: 4px;
    padding-right: 4px;
}

.order-create-form--compact .order-create-form__actions /deep/ .el-button--text:hover {
    color: #606266;
}

.order-create-form /deep/ .el-form-item__label {
    padding-bottom: 8px;
    color: #909399;
    font-weight: 500;
}

.order-create-form /deep/ .el-input__inner,
.order-create-form /deep/ .el-select .el-input__inner {
    height: 42px;
    border-color: #d9e1ec;
    border-radius: 10px;
}

.order-create-form /deep/ .el-input-number {
    width: 100%;
}

.order-create-form /deep/ .order-create-form__readonly-input .el-input__inner {
    color: #5c6166;
    background: #f8fafc;
}

.order-create-form /deep/ .el-input-number .el-input__inner {
    padding-left: 50px;
    padding-right: 50px;
    text-align: center;
}

.order-create-form /deep/ .el-input-number__decrease,
.order-create-form /deep/ .el-input-number__increase {
    width: 38px;
    border-color: #d9e1ec;
    background: #eef5ff;
    color: #4b83d5;
}

.order-create-form__actions /deep/ .el-button {
    min-width: 98px;
    height: 40px;
    border-radius: 20px;
}

.order-create-form__actions /deep/ .el-button--default {
    border-color: #d9e1ec;
}

.order-create-form__actions /deep/ .el-button--primary {
    background: linear-gradient(180deg, #5aa8ff 0%, #3d8df5 100%);
    border-color: #3d8df5;
}

.order-create-form__channel-fees {
    margin-top: 2px;
}

.order-create-form__channel-fees-title {
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.order-create-form__channel-fees-title--compact {
    font-size: 14px;
}

.order-create-form__channel-fee-input /deep/ .el-input-number {
    width: 100%;
}

.order-create-form__channel-fee-input /deep/ .el-input-number .el-input__inner {
    padding-left: 12px;
    padding-right: 12px;
    text-align: left;
}

.order-create-form__channel-fee-readonly /deep/ .el-input__inner {
    color: #5c6166;
    background: #f8fafc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/OrderCreateForm.vue